<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
import { getList } from "@/api/order/modifyCodRecords";
import { getOrderDetails } from "@/api/order/list";
import Tracker from "@/base/order_tracker";
import { getAllClient } from "@/api/user/client";
import { getAgent } from "@/api/tracker/agent";
import { getSelectType } from "@/api/public";
import { getCurrency } from "@/api/finance/currency";
import { getUser } from "@/api/user/internal";
import cTable from "@/base/common/index";
import { getCountry } from "@/api/system/country";
import { getAllService } from "@/api/user/internal";
export default {
  name: "modifyCodRecords",
  components: {
    cTable,
    Tracker,
  },
  async created() {
    let client = (await getAllClient()).data.payload.rows;
		const data = (await getAllService()).data.payload;
		let service = [];
		[1, 2, 3].forEach(item => {
		  service = service.concat(data[item]);
		});
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id") item.options = client;
			if (item.key === "customer_service_id") item.options = service;
			if (item.key === "deliver")item.options = (
			      await getAgent({ agent_type: "bag", status: "YES", types: "DELIVERY" })
			    ).data.payload.rows;
			if (item.key === "to_country")
			  item.options = (await getCountry()).data.payload.rows;
    });
  },
  data() {
    return {
      amount: 0,
      methods: {
        list: getList,
        getAllClient,
        // getDetails
      },
      config: {
        height: 630,
      },
      modals: {},
      header: {
        searchs: [
          {
            key: "client_id",
            component: "Select",
            bind: {
              style: "width:175px",
            },
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
					{
					  key: "to_country",
					  component: "Select",
					  bind: {
					    style: "width:150px",
					  },
					  placeholder() {
					    return this.$t("select") + this.$t("target_country");
					  },
					  options: [],
					  config: { label: "code", value: "code" },
					},
					{
						key: "customer_service_id",
						component: "Select",
						placeholder() {
							return this.$t("serviceAccount");
						},
						clearable: true,
						options: []
					},
					{
						key: "deliver",
						component: "Select",
						placeholder() {
							return this.$t("localFaction");
						},
						clearable: true,
						options: [],
						config: { label: "agent_name", value: "agent_name" }
					},
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
              // autosize: { minRows: 2, maxRows: 2 }
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("cod_amount1"),
          key: "amount",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("old") + this.$t("cod_amount1"),
          key: "old_amount",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("CustomerNote"),
          key: "remarks",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("WarehouseNotes"),
          key: "status_remarks",
          align: "center",
          minWidth: 95,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          minWidth: 95,
        },
				{
				  name: () => this.$t("serviceAccount"),
				  key: "customer_service_name",
				  align: "center",
				  minWidth: 95,
				},
				{
				  name: () => this.$t("warehouse")+this.$t('operation')+this.$t('time'),
				  key: "warehouse_time",
				  align: "center",
				  minWidth: 95,
				},
				{
				  name: () => this.$t("allow_arrive"),
				  key: "to_country",
				  align: "center",
				  minWidth: 95,
				},
				{
				  name: () => this.$t("localFaction"),
				  key: "deliver",
				  align: "center",
				  minWidth: 95,
				},
        {
          name: () => this.$t("addTime"),
          key: "create_time",
          align: "center",
          minWidth: 170,
        },
        // {
        //   type: "btns",
        //   width: 100,
        //   name: () => this.$t("operation"),
        //   fixed: "right",
        //   list: [
        //     {
        //       name: () => this.$t("operation"),
        //       type: "operation",
        //       fnName: "operationFun",
        //       bind: {
        //         type: "warning"
        //       }
        //     }
        //   ],

        //   methods: {
        //     operationFun({ row }) {
        //       this.getModal("operation").open({ id: row.airway_number });
        //     }
        //   }
        // }
      ],
    };
  },
};
</script>
